import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ResponseErrorBody, ResponseErrorBodyDataNewLocation } from '../types';

export default function(props: { error: ResponseErrorBody }) {
  const { t } = useTranslation('translation');

  const newLocationData = props.error.data as ResponseErrorBodyDataNewLocation;

  /**
   * view of place from data in error
   * @param newLocationData
   */
  function placeByData(newLocationData: ResponseErrorBodyDataNewLocation) {
    return `${newLocationData.continentName} - ${newLocationData.countryName} - ${newLocationData.region} - ${newLocationData.city}`;
  }

  /**
   * view of coordinates from data in error
   * @param newLocationData
   */
  function coordinatesByData(
    newLocationData: ResponseErrorBodyDataNewLocation
  ) {
    return `${newLocationData.latitude},${newLocationData.longitude}`;
  }

  return (
    <Typography variant="body1">
      {t('newLocationErrorMessage', {
        place: placeByData(newLocationData),
        coordinates: coordinatesByData(newLocationData)
      })}
    </Typography>
  );
}
